import { render, staticRenderFns } from "./PollResult.vue?vue&type=template&id=52f18069&scoped=true&"
import script from "./PollResult.vue?vue&type=script&lang=js&"
export * from "./PollResult.vue?vue&type=script&lang=js&"
import style0 from "./PollResult.vue?vue&type=style&index=0&id=52f18069&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f18069",
  null
  
)

export default component.exports